// extracted by mini-css-extract-plugin
module.exports = {"myserviceWrapper":"MyServices_view_myserviceWrapper__QZoxw"};